import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../infrastructure/redux/store';
import { useAlocacaoPageQuery } from '../graphql/queries/alocacao_page.query';
import { GradeAlocacoes } from '../components/grade_alocacoes';
import { Container } from '../components/container/styles';
import { Menu } from '../components/menu';
import { limparDados } from '../reducers/alocacao.reducer';

const AlocacaoPage: React.FC = () => {
  const { grades } = useSelector((state: RootState) => state.alocacao);

  const { data: dados } = useAlocacaoPageQuery();

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = 'SisIEC - Alocação de Aulas';

    return () => {
      dispatch(limparDados());
    };
  }, []);

  return (
    <Container>
      <Menu
        periodos={dados?.periodos}
        cursos={dados?.cursos}
        professores={dados?.professores}
        disciplinas={dados?.disciplinas}
        horarios={dados?.horarios}
      />
      <GradeAlocacoes grades={grades} />
    </Container>
  );
};

export { AlocacaoPage };
